export const routes = {
  home: '/',
  africa: '/africa',
  americas: '/americas',
  asia: '/asia',
  europe: '/europe',
  oceania: '/oceania',
  countries: '/countries/:id',
  connectionFailed: '/connection-failed'
};
